export default __webpack_public_path__ + "static/media/pd-logo.c09ceefc.jpg";